<template>
  <v-container class="debicheck-container">
    <v-card class="elevation-3 rounded-lg pa-4">
      <div class="debicheck-faqs">
        <!-- DebiCheck FAQs Section -->
        <h2 class="text-h5 font-weight-bold primary--text mb-4">
          DebiCheck FAQs
        </h2>

        <v-expansion-panels flat>
          <!-- What is DebiCheck? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              What is DebiCheck?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p class="body-1 mb-3">
                  <b>DebiCheck</b> is an initiative by the
                  <b>Payments Association of South Africa (PASA)</b> designed to
                  give consumers more control over their debit orders. <br />
                  It requires you to <b>electronically confirm</b> the details
                  of a debit order before it is processed—helping prevent
                  unauthorised deductions from your account.
                </p>
                <p class="body-1 mb-3">
                  You can confirm your debit order via your
                  <b>bank's app, ATM, online banking</b>, or other available
                  channels.
                </p>
                <v-alert text color="info" icon="mdi-link" class="mt-4">
                  Learn more at
                  <a
                    href="https://www.debicheck.co.za"
                    class="text-decoration-none font-weight-medium"
                    target="_blank"
                  >
                    www.debicheck.co.za
                  </a>
                </v-alert>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- What is the purpose of DebiCheck? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              What is the purpose of DebiCheck?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <p class="body-1 mb-3">
                  DebiCheck was introduced to
                  <b>combat debit order fraud</b> and ensure transparency in
                  payment authorisation.
                </p>
                <p class="body-1 mb-2">It addresses two key issues:</p>
                <v-list dense class="flex-wrap">
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="error">mdi-shield-alert</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap"
                        >Unauthorised debit orders being processed without your
                        consent</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-icon>
                      <v-icon color="warning">mdi-alert-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="text-wrap"
                        >Customers disputing valid debit orders, which affects
                        both banks and businesses</v-list-item-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <p class="body-1 mt-3">
                  By confirming each debit order upfront, DebiCheck protects
                  both you and your financial service provider.
                </p>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- How does DebiCheck work? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              How does DebiCheck work?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text class="pa-0">
                <v-stepper vertical>
                  <v-stepper-step step="1" complete>
                    Choose your <b>loan amount</b> and <b>repayment period</b>
                  </v-stepper-step>
                  <v-stepper-content step="1"> </v-stepper-content>

                  <v-stepper-step step="2" complete>
                    Confirm the <b>debit order details</b> via your bank's
                    platform (e.g. app, ATM, online)
                  </v-stepper-step>
                  <v-stepper-content step="2"> </v-stepper-content>

                  <v-stepper-step step="3" complete>
                    Once confirmed, we are notified, and the
                    <b>payment is securely scheduled</b>
                  </v-stepper-step>
                  <v-stepper-content step="3"> </v-stepper-content>
                </v-stepper>

                <v-alert text type="info" icon="mdi-check-circle" class="mt-4">
                  You only need to confirm the debit order <b>once per loan</b>.
                </v-alert>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <!-- Is DebiCheck safe to use? -->
          <v-expansion-panel>
            <v-expansion-panel-header
              class="text-subtitle-1 font-weight-bold primary--text"
            >
              Is DebiCheck safe to use?
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text class="pa-1">
                <v-card outlined class="pa-4 mb-4">
                  <v-card-text>
                    <p class="body-1">
                      Yes. DebiCheck uses
                      <b>industry-standard security protocols</b> as outlined by
                      PASA. Your bank will guide you through a secure process to
                      confirm each transaction. This adds an
                      <b>extra layer of protection</b> to your banking activity.
                    </p>
                  </v-card-text>
                </v-card>

                <v-alert text color="info" icon="mdi-lock" class="mt-4">
                  🔐 For more information, visit
                  <a
                    href="https://www.debicheck.co.za"
                    class="text-decoration-none font-weight-medium"
                    target="_blank"
                  >
                    www.debicheck.co.za
                  </a>
                </v-alert>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "DebiCheckComponent",
  data() {
    return {};
  },
};
</script>

<style scoped>
.debicheck-container {
  max-width: 900px;
  margin: 0 auto;
  padding-top: 24px;
  padding-bottom: 24px;
}
</style>
